import { Box, Button, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { IProduct } from '../types/Product';
import Image from 'react-cool-img';
import gqlUrl from '../constants/gqlUrl';
import { convertToPriceFormat, useScreenResolution } from '../utils/utils';

interface ICartItem {
  item: IProduct;
  onAddClick: (item: IProduct) => void;
  onRemoveClick: (item: IProduct) => void;
}

const CartItem: FC<ICartItem> = ({ item, onAddClick, onRemoveClick }) => {
  const isDesktop = useScreenResolution();
  const imgUrl = `${gqlUrl}${item.imgUrl}`;

  const renderButtons = (item: IProduct) => {
    return (
      <Stack flexDirection="row" alignItems="center" paddingY="10px">
        <Button
          sx={{ minWidth: '15px', height: '25px', width: '15px' }}
          variant="outlined"
          onClick={() => onRemoveClick(item)}
        >
          -
        </Button>
        <Typography sx={{ margin: '0 10px' }}>{item?.quantity}</Typography>
        <Button
          sx={{ minWidth: '15px', height: '25px', width: '15px' }}
          variant="outlined"
          onClick={() => onAddClick(item)}
        >
          +
        </Button>
      </Stack>
    );
  };

  return (
    <Stack flexDirection="row" sx={{ margin: '30px 0' }}>
      <Box>
        <Image
          src={imgUrl}
          alt="cover"
          style={{
            width: '60px',
          }}
        />
      </Box>
      <Box
        sx={{
          flex: 1,
          marginLeft: 3,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Stack flexDirection="row" justifyContent="space-between">
          <Stack flexDirection="column">
            <Typography variant="subtitle1">{item.title}</Typography>
            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
              {item.formattedPrice} x 1
            </Typography>
            {Number(item?.quantity) > 1 && (
              <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                Total:{' '}
                {convertToPriceFormat(item.price * Number(item?.quantity))}
              </Typography>
            )}
            {!isDesktop && renderButtons(item)}
          </Stack>
          {isDesktop && <Box textAlign="right">{renderButtons(item)}</Box>}
        </Stack>
      </Box>
    </Stack>
  );
};

export default CartItem;
